import { render, staticRenderFns } from "./SlcNoFeedDialog.vue?vue&type=template&id=4790ef8a&"
import script from "./SlcNoFeedDialog.vue?vue&type=script&lang=js&"
export * from "./SlcNoFeedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports